import { InputBase } from "components/Atoms/formInputs/InputBase";
import { useValidate } from "formvalidation/hooks";
import classNames from "classnames";
import React, { useRef } from "react";
import { isNullOrEmptyString } from "shared/utils";

interface Props {
  firstName: string;
  insertion: string;
  lastName: string;

  onChange: (firstName: string, insertion: string, lastName: string) => void;
  onEnter?: () => void;
  onEsc?: () => void;
  className?: string;
  focusOnMount?: boolean;
}

export const ContactName = (props: Props) => {
  const { firstName, insertion, lastName, onChange } = props;

  const inputRef = useRef<HTMLInputElement>(null);
  const validation = useValidate({
    key: "contactName",
    title: "Contact Name",
    value: [firstName, lastName],
    dependencies: [firstName, lastName],
    ref: inputRef,
    validate: async () => !isNullOrEmptyString(firstName) || !isNullOrEmptyString(lastName)
  });

  const parentClass = classNames("flex gap-small", props.className);
  const growClass = classNames("grow1");

  return (
    <div className={parentClass}>
      <div className={growClass}>
        <InputBase
          ref={inputRef}
          focusOnMount={props.focusOnMount}
          maxLength={serverReference.constants.personName.maxFirstNameLength}
          value={firstName}
          onChange={(value) => onChange(value, insertion, lastName)}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
          placeholder={RESX.Contact.FirstNameHelpText}
          error={validation.error.hasError}
        />
      </div>
      <div className={growClass}>
        <InputBase
          maxLength={serverReference.constants.personName.maxInsertionLength}
          value={insertion}
          onChange={(value) => onChange(firstName, value, lastName)}
          placeholder={RESX.Contact.MiddleNameHelpText}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
        />
      </div>
      <div className={growClass}>
        <InputBase
          maxLength={serverReference.constants.personName.maxLastNameLength}
          value={lastName}
          onChange={(value) => onChange(firstName, insertion, value)}
          placeholder={RESX.Contact.LastNameHelpText}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
        />
      </div>
    </div>
  );
};